import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import { NavLink } from "react-router-dom";
import { AppLoader } from "../components/app-loader";
import { WEB_ROUTES } from "../routes/web-routes";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";

export default function Project() {
  const [page, setPage] = useState({});
  const [loading, setLoading] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  const [map, setMap] = useState([]);
  const [fundsMedia, setFundsMedia] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  let { getMetaSnippet, getSeoTitle, getSeoDescription } = useUtilities();

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "project"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};

        setPage(pageResponse);

        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  useEffect(() => {
    if (page?.acf?.sub_section_image) {
      axios
        .get(CONTENT_ROUTES.MEDIA_BY_ID(page?.acf?.sub_section_image))
        .then((res) => {
          setMap(res.data?.source_url);
        });
    }
  }, [page]);

  return (
    <>
      <Helmet>
        <title>
          {getSeoTitle(page, page?.title?.rendered + ` - Nant Power`)}
        </title>
        <meta
          name="description"
          content={getSeoDescription(
            page,
            getMetaSnippet(page?.content?.rendered)
          )}
        />
      </Helmet>
      <Header />
      <main>
        <section className="relative">
          <div className="absolute z-10 bottom-0 left-0 w-full h-1/2 md:bg-gradient-to-t from-black/60 to-transparent"></div>
          <div
            className="bg-black bg-no-repeat bg-top md:bg-cover md:pt-16 bg-[length:auto_60%]"
            style={{
              backgroundImage: `url(
              ${
                pageMedia?.find((media) => media?.id === page?.featured_media)
                  ?.source_url
              }
            )`,
            }}
          >
            <div className="container mx-auto pt-[470px] 2xl:pt-[680px] px-8 md:px-0">
              <h1 className="text-4xl font-medium text-[#58b947]">
                {page?.title?.rendered}
              </h1>
            </div>
            <div className="container mx-auto md:flex ">
              <div className="md:w-2/5 w-full pt-10 md:pb-16 pb-0 px-8 md:px-0 text-white z-30">
                <div className="relative">
                  <h2
                    className="md:text-4xl text-2xl font-medium relative"
                    dangerouslySetInnerHTML={{
                      __html: page?.content?.rendered
                        ?.replace(/<p.*?>*?<\/p>/g, "")
                        ?.replace(/<h2.*?>/g, "<h2 class='md:pr-20'>"),
                    }}
                  />
                </div>
              </div>
              <div className="md:w-3/5 w-full pt-10 pb-16 md:px-10 px-8 text-white z-30">
                <div
                  dangerouslySetInnerHTML={{
                    __html: page?.content?.rendered
                      ?.replace(/<h2.*?>*?<\/h2>/g, "")
                      ?.replace(/<p>/g, "<p class='mb-4'>"),
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#0071b9] pt-16">
          <div className="container mx-auto">
            <div className="md:w-full flex content-center md:px-0 px-8 text-white">
              <div className="flex">
                <img
                  className="mr-5 h-12 -mt-2"
                  src="/images/electric-bolt-solid.svg"
                  alt="Nant Power Project Icon"
                />
                <div className="text-xl font-bold">Project Overview</div>
              </div>
            </div>
          </div>

          <div className="container mx-auto mt-10 relative">
            {/* Background Layer */}
            <div className="absolute right-0 top-0 md:w-4/5 w-4/6 h-full bg-gradient-to-b from-[#045994] to-transparent z-0"></div>
            {/* Foreground Content Layer */}
            <div className="relative z-10">
              <div className="flex text-white ">
                <div className="md:w-1/5 w-2/6 text-right p-4 border-t border-white">
                  Capacity
                </div>
                <div className="md:w-4/5 w-4/6 text-left p-4 border-t border-white">
                  {page?.acf?.project_capacity}
                </div>
              </div>
              <div className="flex text-white">
                <div className="md:w-1/5 w-2/6 text-right p-4 border-t border-white">
                  Technology
                </div>
                <div className="md:w-4/5 w-4/6 text-left p-4 border-t border-white">
                  {page?.acf?.project_technology}
                </div>
              </div>
              <div className="flex text-white">
                <div className="md:w-1/5 w-2/6 text-right p-4 border-t border-white">
                  Location
                </div>
                <div className="md:w-4/5 w-4/6 text-left p-4 border-t border-white">
                  {page?.acf?.project_location}
                </div>
              </div>
              <div className="flex text-white">
                <div className="md:w-1/5 w-2/6 text-right p-4 border-t border-white">
                  Status
                </div>
                <div className="md:w-4/5 w-4/6 text-left p-4 border-t border-white">
                  {page?.acf?.project_status}
                </div>
              </div>
              <div className="flex text-white">
                <div className="md:w-1/5 w-2/6 text-right p-4 border-t border-white">
                  Expected First Power
                </div>
                <div className="md:w-4/5 w-4/6 text-left p-4 border-t border-white">
                  {page?.acf?.project_target}
                </div>
              </div>
              <div className="flex text-white md:py-5 py-0">
                <div className="md:w-1/5 w-2/6 text-right p-4 border-t border-white">
                  &nbsp;
                </div>
                <div className="md:w-4/5 w-4/6 text-left p-4 border-t border-white">
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#0071b9] md:pt-16 pt-8 pb-24">
          <div className="container mx-auto"></div>

          <div className="container mx-auto px-8 md:px-0">
            <div className="md:flex text-white gap-x-10">
              <div className="font-medium">
                <div className="flex">
                  <img
                    className="mr-5 h-12 -mt-2"
                    src="/images/electric-bolt-solid.svg"
                    alt="Nant Power Project Icon"
                  />
                  <div className="text-xl font-bold">
                    A Catalyst for Regional Impact
                  </div>
                </div>
                <div className="mt-10">{page?.acf?.sub_section}</div>
              </div>

              <img
                src={`${map}`}
                alt="Map"
                className="object-cover md:h-[400px] md:w-auto mt-0 md:-mt-10"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
